import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  formFieldCurrencyWithNotice: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  editorRoot: {
    minHeight: '180px',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '0 16px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fill: 'unset',
    minWidth: '40px',
  },
  warningWrapper: {
    background: '#feeceb',
    color: '#6f2b27',
    padding: '18px 16px',
    fontSize: '14px',
    borderRadius: '4px',
  },
  ctaButton: {
    color: theme.palette.primary.light,
    paddingLeft: '0px',
    paddingBottom: '0px',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  availabilitySection: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  incrementHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
}))

export default useStyles
